import { ObjectModel } from 'objectmodel';

const Notification = new ObjectModel({
  title: String,
  options: Object
});

const Toast = new ObjectModel({
  messageL10nId: [String],
  message: [String],
  messageL10nArgs: [Object],
  titleL10nId: [String],
  title: [String],
  titleL10nArgs: [Object]
});

export { Notification, Toast };



/** WEBPACK FOOTER **
 ** ./~/kaistore-post-messenger/src/models/UI.js
 **/